import { Modal } from 'antd';

export const LCModalConfirm = Modal;
